import { colors } from "@src/theme"
import * as ReactTooltip from "react-tooltip"
import styled from "styled-components"

export const TooltipStyled = styled.div<{
  type: ReactTooltip.VariantType
  width?: string
  maxWidth?: string
  textAlign?: "right" | "left" | "center"
  pointerEvents?: string
}>`
  .tooltip-content-custom {
    pointer-events: ${({ pointerEvents }) => pointerEvents};
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    padding: 10px 10px;
    ${({ width = "auto", maxWidth }) =>
      maxWidth
        ? `
    width: fit-content;
    min-width: ${width};
    max-width: ${maxWidth};
    overflow-wrap: normal;
    word-wrap: normal;
    `
        : `
    max-width: ${width};
    width: ${width};
    min-width: 0;
    overflow-wrap: break-word;
    word-wrap: break-word;
    `}
    font-weight: normal;
    text-align: ${({ textAlign }) => textAlign};
    opacity: 1 !important;
    z-index: 9999;

    p {
      margin: 0;
      color: ${({ type }) => (type === "dark" ? colors.white : colors.black50)};
      font-size: 16px;
      line-height: 21px;
      font-weight: normal;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

    h3 {
      font-size: 16px;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

    a {
      color: white;
    }
  }
`
